import {spro_cli_columnGrid} from "./interfaces/spro-columnGrid";
import {Injectable} from "@angular/core";

/*
 * Fichier contenant des variables globales pour les composants sproLib
 */
@Injectable()
export class spro_cls_varGlobal {

  //Format utilisé pour les dates des grids kendo UI
  w_formatDate = "dd-MM-yyyy";

  public h_lst_colummns: Array<{w_id: string, h_cols: spro_cli_columnGrid[]}> = [];

}


// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/spro-varGlobal.ts